// Remove Vietnamese diacritics and get only the letter
export const removeDiacritics = (str: string): string => {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D");
};

// Generate beautiful gradient colors based on first letter
export const getAvatarGradient = (char: string): string => {
  const gradients = [
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // Purple
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", // Pink
    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)", // Blue
    "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)", // Green
    "linear-gradient(135deg, #fa709a 0%, #fee140 100%)", // Orange-Pink
    "linear-gradient(135deg, #30cfd0 0%, #330867 100%)", // Cyan-Purple
    "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)", // Light Blue-Pink
    "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)", // Light Pink
    "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)", // Peach
    "linear-gradient(135deg, #ff6e7f 0%, #bfe9ff 100%)", // Red-Blue
    "linear-gradient(135deg, #c471f5 0%, #f64f59 100%)", // Purple-Red
    "linear-gradient(135deg, #12c2e9 0%, #c471ed 100%)", // Blue-Purple
    "linear-gradient(135deg, #fbc2eb 0%, #a6c1ee 100%)", // Pink-Blue
    "linear-gradient(135deg, #fad961 0%, #f76b1c 100%)", // Yellow-Orange
    "linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)", // Light Blue
    "linear-gradient(135deg, #fdbb2d 0%, #22c1c3 100%)", // Yellow-Cyan
    "linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)", // Pink-Orange
    "linear-gradient(135deg, #8360c3 0%, #2ebf91 100%)", // Purple-Green
    "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)", // Red-Orange
    "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)", // Dark Blue
    "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)", // Red-Pink
    "linear-gradient(135deg, #f09819 0%, #edde5d 100%)", // Orange-Yellow
    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // Purple (repeat)
    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)", // Pink (repeat)
    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)", // Blue (repeat)
    "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)", // Green (repeat)
  ];
  
  if (!char) return gradients[0];
  const normalizedChar = removeDiacritics(char);
  const index = normalizedChar.charCodeAt(0) % gradients.length;
  return gradients[index];
};

// Get the first letter without diacritics for avatar display
export const getAvatarLetter = (name: string | undefined): string => {
  if (!name) return "A";
  const firstChar = name.charAt(0);
  return removeDiacritics(firstChar).toUpperCase();
};

